import * as proceduresLib from '../api/procedures.js';
import { fetchLoadable } from '../fetchLoadable.js';
import * as actionTypes from './actionTypes.js';
export const get = (casualConsistency) => fetchLoadable(actionTypes.FETCH_PROCEDURES, proceduresLib.get, {
    casualConsistency,
});
//# sourceMappingURL=actions.js.map